import createStateReducer from "../../helpers/createStateReducer";
import states from "../../states/courseInformationModal";
import deltas from "../../actions/deltas";

const {SET_COURSE_INFORMATION_MODAL_STATE} = deltas.actionTypes;

export default createStateReducer(states, states.CLOSED, SET_COURSE_INFORMATION_MODAL_STATE);
